import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import clsx from "clsx";
import {DataTableLocalization, Translate} from "../../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import {connect, getStore} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../../config/design/TableIcons";
import Button from "@material-ui/core/Button/Button";
import {Link, withRouter} from 'react-router-dom';
import AddBox from "@material-ui/icons/AddBox";
import { withSnackbar } from 'notistack';
import {TableCount, TablePage} from "../../../../../config/Permissions";
import moment from "jalali-moment";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import FilterListRoundedIcon from '@material-ui/icons/FilterListRounded';
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import AppCardLoaderTable from "../../../../components/Skeletons/AppCardLoaderTable";
import IconButton from "@material-ui/core/IconButton/IconButton";
import withWidth from "@material-ui/core/withWidth/withWidth";
import TextField from "@material-ui/core/TextField/TextField";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import Feature from "../../../../components/elements/Feature";
import {colors} from "../../../../../config/values";


class People extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    fixedHeightPaper = clsx(this.classes.paper, this.classes.fixedHeight);
    status = this.props.match.params.status;
    state = {
        columns: [
            {
                title: Translate.personName,
                field: 'name',
                editable: 'never',
                render: rowData =>
                    !!rowData.nickname ? rowData.name+" ("+rowData.nickname+")" : rowData.name
            },
            { title: Translate.status,
                field: 'status',
                editable: 'never',
                lookup: {
                    "pending_for_call" :
                        <Typography className="order_badge" style={{backgroundColor: colors.pending_for_call}}>{Translate.pending_for_call}</Typography>
                    ,"not_answered" :
                        <Typography className="order_badge" style={{backgroundColor: colors.not_answered}}>{Translate.not_answered}</Typography>
                    , "bad_customer":
                        <Typography className="order_badge" style={{backgroundColor: colors.bad_customer}}>{Translate.bad_customer}</Typography>
                    , "contract":
                        <Typography className="order_badge" style={{backgroundColor: colors.contract}}>{Translate.contract}</Typography>
                    , "maybe":
                        <Typography className="order_badge" style={{backgroundColor: colors.maybe}}>{Translate.maybe}</Typography>
                    , "done":
                        <Typography className="order_badge" style={{backgroundColor: colors.done}}>{Translate.done}</Typography>
                    , "end":
                        <Typography className="order_badge" style={{backgroundColor: colors.end}}>{Translate.end}</Typography>
                },
            },
            {
                title: Translate.mobile,
                field: 'mobile',
                editable: 'never',
                render: rowData =>
                    <span dir="ltr">{rowData.mobile}</span>
            },

            {
                title: Translate.first_impression,
                editable: 'never',
                field: 'first_impression_at',
                render: rowData =>
                    <Typography className="date_in_table">
                        {`${moment(rowData.first_impression_at).locale('fa').fromNow()}`}
                        <br/>
                        {`${moment(rowData.first_impression_at).locale('fa').format( 'YYYY/M/D')}`}
                    </Typography>
            },
            { title: Translate.activity,
                editable: 'never',
                field: 'activity',
                render: rowData =>
                    <Button
                        variant="outlined"
                        color="primary"
                        component={Link}
                        to={`/manage/person/${rowData.id}`}
                        endIcon={<ChevronLeftRoundedIcon/>}
                        size={"small"}
                        style={{marginBottom:5,marginRight:5}}
                    >
                        {Translate.details}
                    </Button>
            },

        ],
        data: [],
        loading:false,
        status:"all",
        ChangeLoader:false
    };
    componentDidMount(){
        this.loadData();
    }
    async componentDidUpdate(newProps){
        if(newProps !== this.props){
            let newStatus = this.props.match.params.status;
            await this.setState({
                status:!!newStatus ? newStatus : "all",
                ChangeLoader:true
            })
            await this.loadData();
        }
    }
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    onDeleteUser(id,hasNotif = true) {
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/removePerson`, data, config)
            .then(response => {
                if(hasNotif){
                    this.props.enqueueSnackbar(Translate.deleteData, {
                        variant: 'success',
                    });
                }
                this.loadData();
                return true
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.deleteDataFailed, {
                    variant: 'error',
                });
                this.loadData();
                return false
            });
    }

    async handleChangeStatus(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let status = target.value;
        await this.setState({
            status
        });
        this.props.history.push(`/manage/people/view/${status}`)

        this.loadData();
    }

    render(){
        let loginToken = localStorage.getItem('ACT');
        let {status} = this.state;
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        const data = new FormData();
        data.append('status', status);
        return (
                <>
                    {
                        this.state.loading ? <AppCardLoaderTable/> :
                            <Container maxWidth="xl">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} >
                                        <Grid container spacing={2} direction="row" className={this.classes.filterContainer}>
                                            <Grid item xs={12} md={3} lg={1}>
                                                <Typography>
                                                    <FilterListRoundedIcon/>
                                                    {Translate.filters}:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={3} lg={2}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    value={status}
                                                    onChange={this.handleChangeStatus.bind(this)}
                                                    >
                                                    <MenuItem value={"pending_for_call"}>
                                                        {Translate.pending_for_call}
                                                    </MenuItem>
                                                    <MenuItem value={"not_answered"}>
                                                        {Translate.not_answered}
                                                    </MenuItem>
                                                    <MenuItem value={"end"}>
                                                        {Translate.end}
                                                    </MenuItem>
                                                    <MenuItem value={"bad_customer"}>
                                                        {Translate.bad_customer}
                                                    </MenuItem>
                                                    <MenuItem value={"maybe"}>
                                                        {Translate.maybe}
                                                    </MenuItem>
                                                    <MenuItem value={"contract"}>
                                                        {Translate.contract}
                                                    </MenuItem>
                                                    <MenuItem value={"done"}>
                                                        {Translate.done}
                                                    </MenuItem>
                                                        <MenuItem value='all'>{Translate.all}</MenuItem>
                                                    </TextField>
                                            </Grid>
                                            <Feature check="export_users">
                                            <Grid item xs={12} md={3} lg={2}>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    startIcon={<GetAppRoundedIcon/>}
                                                    onClick={
                                                        () =>
                                                            window.open(`${defaultVariabls.website}/export-users`)
                                                    }

                                                >
                                                    {Translate.exportUsersList}
                                                </Button>
                                            </Grid>
                                            </Feature>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <MaterialTable
                                            parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                                            tableRef={this.tableRef}
                                            icons={tableIcons}
                                            title={
                                                <Link to='/manage/people/add'>
                                                    {
                                                        this.props.width !== "xs" ?
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                startIcon={<AddBox/>}
                                                            >
                                                                {Translate.addPerson}
                                                            </Button>
                                                            :
                                                            <IconButton color="primary">
                                                                <AddBox/>
                                                            </IconButton>
                                                    }
                                                </Link>
                                            }

                                            localization={DataTableLocalization}
                                            columns={this.state.columns}
                                            data={query =>
                                                new Promise((resolve, reject) => {
                                                    axios.post(`${defaultVariabls.url}/getPeople/withFilter?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`,data, config)
                                                        .then(response => {
                                                            let data = [];
                                                            // eslint-disable-next-line
                                                            response.data.data.map((row) => {
                                                                data.push({
                                                                    name: row.name,
                                                                    nickname: row.nickname,
                                                                    id: row.id,
                                                                    mobile:row.mobile,
                                                                    status:row.status,
                                                                    created_at:row.created_at,
                                                                    first_impression_at:!!row.first_impression_at ? row.first_impression_at : row.created_at,
                                                                })
                                                            });
                                                            resolve({
                                                                data: data,
                                                                page: response.data.current_page - 1,
                                                                totalCount: response.data.total,
                                                            })
                                                        }).catch(error => {
                                                        console.log(error.response)
                                                    })
                                                })
                                            }
                                            options={{
                                                pageSize: TablePage,
                                                pageSizeOptions: TableCount,
                                                sorting:false,
                                                draggable:false,
                                            }}

                                            editable={{
                                                onRowDelete: oldData =>
                                                    new Promise(resolve => {
                                                        setTimeout(() => {
                                                            resolve();
                                                            this.onDeleteUser(oldData.id);
                                                            this.setState(prevState => {
                                                                const data = [...prevState.data];
                                                                data.splice(data.indexOf(oldData), 1);
                                                                return { ...prevState, data };
                                                            });
                                                        }, 600);
                                                    }),
                                            }}

                                        />
                                    </Grid>
                                </Grid>
                            </Container>
                    }
                </>
        );
    }
}
const mstp = state => ({
    features: state.features
});
export default  withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(People)))));

